import { Box, Button, Collapse, Grid, Typography, useTheme } from "@mui/material"
import useAuth from "../../../../../../context/auth"
import { usePageTitle } from "../../../../../../hooks"
import { BsCheckCircle } from "react-icons/bs"
import { PiHandWithdraw, } from "react-icons/pi"
import { useEffect, useState } from "react"
import moment from "moment"
import { Format } from "../../../../../../utils"
import { IMovements } from "../../../../../partner/extract"
import { PartnerService } from "../../../../../../services/partner"
import { HiOutlineCurrencyDollar } from "react-icons/hi2"

export const Extract = () => {
    usePageTitle("Indique e ganhe - extrato")
    const { user, handleBack } = useAuth()
    const { palette } = useTheme()
    const [movements, setMovements] = useState<IMovements[]>([])

    const getMovements = () => {
        PartnerService.getMovements(user?.account?.id as number)
            .then(({ data }) => {
                setMovements(data?.movements?.rows)
            })
    }

    useEffect(() => {
        getMovements()
    }, [])


    return (
        <Grid
            display={"flex"}
            direction={"column"}
            gap={"2rem"}
            width={"100%"}
            height={"100%"}
        >
            <Typography
                fontSize={"2rem"}
                fontWeight={600}
                p={0}
            >
                Extrato
            </Typography>

            <Collapse in={movements?.length > 0}>
                <Grid
                    display={"flex"}
                    direction={"column"}
                    gap={"1rem"}
                >
                    {movements?.sort((a, b) => b.id - a.id).map((item, i) => {
                        const firstPaid = movements.findIndex((item) => item.value < 0)
                        console.log(firstPaid)
                        const paid = i > firstPaid && item.value > 0 && firstPaid >= 0
                        return (
                            <Box
                                display={"flex"}
                                flexDirection={"row"}
                                gap={".5rem"}
                                justifyContent={"space-between"}
                                padding={"2rem 1rem"}
                                boxSizing={"border-box"}
                                width={"100%"}
                                sx={{
                                    backgroundColor: "#FFFFFF",
                                    borderRadius: "10px"
                                }}
                            >
                                <Grid
                                    display={"flex"}
                                    flexDirection={"row"}
                                    alignItems={"flex-start"}
                                    gap={".7rem"}
                                >

                                    {(item.value > 0 && !paid) && <HiOutlineCurrencyDollar style={{
                                        minWidth: "25px",
                                        minHeight: "25px",
                                        marginTop: ".2rem",
                                        paddingLeft: ".5rem"
                                    }} color="rgba(73, 184, 79, 1)" />}

                                    {paid && <BsCheckCircle style={{
                                        minWidth: "25px",
                                        minHeight: "25px",
                                        marginTop: ".2rem",
                                        paddingLeft: ".5rem"
                                    }} color={palette.primary.main} />}

                                    {item.value < 0 && <PiHandWithdraw style={{
                                        minWidth: "25px",
                                        minHeight: "25px",
                                        marginTop: ".2rem",
                                        paddingLeft: ".5rem"
                                    }} color={palette.error.main} />}

                                    <Grid
                                        display={"flex"}
                                        flexDirection={"column"}
                                        gap={".5rem"}
                                    >
                                        <Typography fontSize={"1.6rem"} fontWeight={600}>{(item.value > 0 && !paid) ? "Contrato disponível" : paid ? "Contrato pago" : "Saque"}</Typography>
                                        <Typography fontSize={"1.6rem"} lineHeight={"1.9rem"} sx={{ opacity: .5 }}>Data: {moment().isSame(moment(item.createdAt), "date") ? "Hoje" : moment().subtract(1, "day").isSame(moment(item.createdAt), "date") ? "Ontem" : moment(item.createdAt).format("DD/MM/YYYY")}</Typography>
                                        {item.value > 0 && <Typography fontSize={"1.6rem"} lineHeight={"1.9rem"} sx={{ opacity: .5 }}>{item?.extraData?.client?.name}</Typography>}
                                    </Grid>
                                </Grid>
                                <Grid
                                    display={"flex"}
                                    flexDirection={"column"}
                                    alignItems={"flex-end"}
                                    justifyContent={"flex-start"}
                                >
                                    <Typography fontSize={"2rem"} textAlign={"right"} fontWeight={600} color={(item.value > 0 && !paid) ? "#49B84F" : paid ? palette.primary.main : "#DA1717E5"} lineHeight={"2.4rem"}>{Format.currencyWithoutDecimals(item.value).replace("-", "")}</Typography>
                                </Grid>
                            </Box>
                        )
                    })}
                </Grid>
            </Collapse>
            <Grid
                width={"100%"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
            >
                <Button
                    sx={{
                        height: "4rem"
                    }}
                    variant="outlined"
                    onClick={handleBack}
                >Voltar</Button>
            </Grid>
        </Grid>
    )
}